package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.*
import com.starparty.app.astro0.celestialbodies.Star
import com.starparty.app.geometry.SP_Point
import kotlin.math.min

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
object StarFieldRenderer {

    var itsVisMag = 6.0f
    var constTitleSize = 11f

    val MAX_VMAG = 8f
    var constellationColor =
            SP_Colour(90, 90, 255,255) //Color.blue;
    var constellationNameColor = SP_Colour(0,255,255, 255) // CYAN

    fun incrementVisMag(inc: Float) {
        itsVisMag = min(itsVisMag + inc, MAX_VMAG)
    }

    fun getStarToolTipDescription(starField: StarField, p: SP_Point, sky: Sky): String? {
        var text: String? = null
        val star = getStarUnderPoint(starField, p)
        val starRenderer = StarRenderer()

        if (star != null) {
            text = starRenderer.getToolTipText(star, sky)
        }
        return text
    }

    fun getStarStatusBarDescription(starField: StarField, p: SP_Point, sky: Sky): String? {
        var text: String? = null
        val star = getStarUnderPoint(starField, p)
        val starRenderer = StarRenderer()

        if (star != null) {
            text = starRenderer.getStatusBarText(star, sky)
        }
        return text
    }

    fun getStarUnderPoint(starField: StarField, p: SP_Point): Star? {
        var rightStar: Star? = null
        val starRenderer = StarRenderer()
        val stars = starField.stars

        for (s in stars!!.indices) {
            val star = stars!![s]
            if (star.visMag > itsVisMag) break
            if (starRenderer.contains(star, p)) {
                rightStar = star
            }
        }
        return rightStar
    }

    fun paint(starField: StarField, labelType: Int, g: SP_Canvas, p: SP_Paint) {
        val cons =
            starField.constellations
        p.setColour(constellationColor)
        if (starField.isShowingConstellations) {
            for (c in cons!!.indices) {
                paintConstellation(g, cons!![c], p)
            }
        }
        if (starField.isShowingStars) {
            paintStars(starField, labelType, g, p)
        }
        if (labelType != Sky.NO_TITLES) {
            paintConstellationTitles(starField, labelType, g, p)
        }
    }

    fun paintStars(starField:StarField, titleType: Int, g: SP_Canvas, p: SP_Paint) {
//int starRanking = 0;
        val stars = starField.stars
        val starRenderer = StarRenderer()
        for (s in stars.indices) {
            val star = stars[s]
            if (star.visMag > itsVisMag) break
            starRenderer.paint(star, titleType, g, p)
            /*
if (sr.getStar().getConstellationAbbr().equals("Tri"))
{
  Point loc = sr.getSkyLocation();
  g.drawString(Integer.toString(starRanking), loc.x, loc.y);
  starRanking++;
}
*/
        }
    }

    fun paintConstellationTitles(starField: StarField, titleType: Int, g: SP_Canvas, p: SP_Paint) {
        val cons =
            starField.constellations
        p.setColour(constellationNameColor)
        for (c in cons.indices) {
            paintConstellationTitle(cons[c], titleType, g, p)
        }
    }

    fun paintConstellation(g: SP_Canvas, c: Constellation, p: SP_Paint) {

        val stars = c.stars
        val lines = c.lines

        for (l in lines.indices) {
            val line = lines[l]
            var lastPoint = (stars[line[0]] as Star).skyLocation
            var nextPoint: SP_Point? = null

            for (s in 1 until line.size) {
                nextPoint = (stars[line[s]] as Star).skyLocation

                    g.drawLine(
                        lastPoint.x,
                        lastPoint.y,
                        nextPoint.x,
                        nextPoint.y,
                        p
                    )

                lastPoint = nextPoint
            }
        }
    }

    fun paintConstellationTitle(
        c: Constellation,
        labelVersion: Int,
        g: SP_Canvas,
        p: SP_Paint
    ) {
        var name: String = ""
        when (labelVersion) {
            Sky.FULL_TITLES -> name = c.name
            Sky.ABBR_TITLES -> name = c.abbreviation.toUpperCase()
        }
        val cPt = c.titlePoint
        val namePt = cPt.skyLocation

        p.setTextSize(constTitleSize)
        //   Typeface typeface = Typeface.createFromAsset((g.getAssets(), "Helvetica.ttf");
        //   paint.setTypeface(typeface);
        p.setColour(constellationNameColor)
        val boundsResult = p.getTextBounds(name)



            val textHeight = boundsResult.height
            val textWidth = boundsResult.width
            val xPos = namePt.x - textWidth / 2
            val yPos = namePt.y + textHeight / 2
            g.drawText(name, xPos, yPos, p)

    }

    init {

    }
}